import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Facturation.css";

const Facturation = () => {
    const navigate = useNavigate();

    // --- SÉCURITÉ ---
    // On vérifie si l'utilisateur est logué via userId (comme sur ton nouveau Kanban)
    const userName = localStorage.getItem("userName") || "Collaborateur";
    const isAuthenticated = localStorage.getItem("userId") !== null;

    // --- ÉTATS ---
    const [factures, setFactures] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchFactures = async () => {
        try {
            // URL mise à jour vers ton nouveau domaine
            const res = await fetch("https://aurelien.kanban.amservices.eu/api/get_suivis.php");
            const data = await res.json();
            if (data.success) {
                // On filtre pour ne garder que l'ID 400 (Facturation)
                const filteredData = data.data.filter(f => String(f.id_etape) === "400");
                setFactures(filteredData);
            }
        } catch (err) {
            console.error("Erreur factures:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleArchive = async (id) => {
        if (!window.confirm("Confirmer le règlement ? Le dossier sera archivé.")) return;

        try {
            await fetch("https://kanban.amservices.eu/api/update_etape.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: id, id_etape: "500" }), // 500 = Archive
            });
            setFactures(prev => prev.filter(f => f.id !== id));
        } catch (err) { console.error(err); }
    };

    useEffect(() => {
        if (isAuthenticated) {
            fetchFactures();
        } else {
            navigate("/login");
        }
    }, [isAuthenticated, navigate]);

    // --- LOGIQUE DE RECHERCHE ---
    const filteredFactures = factures.filter(f => {
        if (!searchTerm) return true;
        const lowerTerm = searchTerm.toLowerCase();
        return (
            f.client_nom.toLowerCase().includes(lowerTerm) ||
            (f.num_devis && f.num_devis.toLowerCase().includes(lowerTerm)) ||
            (f.num_facture && f.num_facture.toLowerCase().includes(lowerTerm))
        );
    });

    if (loading) return <div className="facturation-page">Chargement @m Services...</div>;

    return (
        <div className="facturation-page">
            <div className="facture-header">
                <button className="btn-back" onClick={() => navigate("/suivi-production")}>
                    ← Retour au Suivi
                </button>

                <div className="header-titles">
                    <h1>Comptabilité & Règlements</h1>
                    <p>{factures.length} dossier{factures.length > 1 ? 's' : ''} en attente</p>
                </div>

                <div className="search-bar-container">
                    <input
                        type="text"
                        placeholder="Rechercher client, devis..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                    />
                </div>
            </div>

            <div className="billing-container">
                <table className="billing-table">
                    <thead>
                        <tr>
                            <th>Client / Objet</th>
                            <th>Références</th>
                            <th>Montant</th>
                            <th>Échéance</th>
                            <th className="th-actions">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredFactures.map((f) => (
                            <tr key={f.id} className="billing-row">
                                <td className="client-cell">
                                    <div className="client-name">{f.client_nom}</div>
                                    <div className="objet-sub">{f.objet_inter}</div>
                                </td>
                                <td>
                                    {f.num_facture && <div className="facture-ref">📄 {f.num_facture}</div>}
                                    {f.num_devis && <div className="devis-ref">📝 {f.num_devis}</div>}
                                </td>
                                <td className="amount-cell">
                                    <strong>{parseFloat(f.montant_chantier).toLocaleString()} €</strong>
                                </td>
                                <td>{new Date(f.date_echeance).toLocaleDateString('fr-FR')}</td>
                                <td className="actions-cell">
                                    <button className="btn-pay" onClick={() => handleArchive(f.id)}>
                                        💰 Encaisser
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {filteredFactures.length === 0 && (
                    <div className="empty-state">
                        <h3>Aucun dossier à traiter</h3>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Facturation;